import { CREATE_FROM_PLAYLIST_MUTATION, GET_ALL_PAGINATED_QUERY, GET_ALL_PAGINATED_INTERNAL_QUERY, UPDATE_MUTATION, GET_PLAYLIST_OR_LEARNING_PATH_QUERY, GET_LEARNING_PATHS_QUERY } from '../../../__generated__/chirp/com/hubspot/learning/center/playlists/rpc/LearningPathChirpService.dfc';
import { useQuery, useMutation } from 'academy-common-lib/utils/DataFetchingClient';
export const useCreateHubspotPlaylistFromPlaylist = ({
  onCompleted
} = {}) => {
  const [createHubspotPlaylistFromPlaylist, {
    loading: createHubspotPlaylistFromPlaylistLoading,
    error: createHubspotPlaylistFromPlaylistError
  }] = useMutation(CREATE_FROM_PLAYLIST_MUTATION, {
    onCompleted
  });
  return {
    createHubspotPlaylistFromPlaylist,
    createHubspotPlaylistFromPlaylistLoading,
    createHubspotPlaylistFromPlaylistError
  };
};
export const useUpdateHubspotPlaylist = ({
  playlistId,
  onCompleted
}) => {
  const [updateHubspotPlaylist, {
    loading: updateHubspotPlaylistLoading,
    error: updateHubspotPlaylistError
  }] = useMutation(UPDATE_MUTATION, {
    onCompleted,
    refetchQueries: [{
      query: GET_PLAYLIST_OR_LEARNING_PATH_QUERY,
      variables: {
        playlistId
      }
    }]
  });
  return {
    updateHubspotPlaylist,
    updateHubspotPlaylistLoading,
    updateHubspotPlaylistError
  };
};
export const useGetAllHubspotPlaylists = () => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_ALL_PAGINATED_QUERY, {
    variables: {
      pageLength: 9999,
      offset: {
        cursor: 0
      }
    }
  });
  return {
    allHubspotPlaylists: (data === null || data === void 0 ? void 0 : data.results.reduce((acc, playlist) => {
      acc[playlist.playlistId] = playlist;
      return acc;
    }, {})) || {},
    allHubspotPlaylistsLoading: loading,
    allHubspotPlaylistsError: error
  };
};
export const useGetAllHubspotPlaylistsAdmin = skip => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_ALL_PAGINATED_INTERNAL_QUERY, {
    skip,
    variables: {
      pageLength: 9999,
      offset: {
        cursor: 0
      }
    }
  });
  return {
    allHubspotPlaylists: (data === null || data === void 0 ? void 0 : data.results.reduce((acc, playlist) => {
      acc[playlist.playlistId] = playlist;
      return acc;
    }, {})) || {},
    allHubspotPlaylistsLoading: loading,
    allHubspotPlaylistsError: error
  };
};

// returns full (including items) HubSpot playlists
export const useHubspotPlaylists = ({
  playlistIds,
  skip
}) => {
  const {
    data,
    loading: hubspotPlaylistsLoading,
    error: hubspotPlaylistsError
  } = useQuery(GET_LEARNING_PATHS_QUERY, {
    variables: {
      learningPathIds: playlistIds
    },
    skip: skip || !playlistIds.length
  });
  return {
    hubspotPlaylists: (data === null || data === void 0 ? void 0 : data.learningPaths.reduce((acc, playlist) => {
      acc[playlist.playlistId] = playlist;
      return acc;
    }, {})) || null,
    hubspotPlaylistsLoading,
    hubspotPlaylistsError
  };
};